// Valores por defecto de modules.
export const defaultModules = () => {
    return [];
}

// Valores por defecto de categories.
export const defaultCategories = () => {
    return [];
}

// Valores por defecto de subcategories.
export const defaultSubcategories = () => {
    return [];
}

// Valores por defecto de form.
export const defaultForm = () => {
    return {
        id: null,
        name: null,
        form_module_id: null,
        form_category_id: null,
        components: [],
    };
}

// Valores por defecto de formBuilders.
export const defaultFormBuilders = () => {
    return [];
}

// Valores por defecto de filterForms.
export const defaultFilterForms = () => {
    return {
        name: null,
        form_module_id: null,
        form_category_id: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de categoriesForModule.
export const defaultCategoriesForModule = () => {
    return [];
}

// Valores por defecto de formByCategory.
export const defaultFormByCategory = () => {
    return {
        components: [],
    };
}

// Valores por defecto de submissionsEpps.
export const defaultSubmissionsEpps = () => {
    return [];
}

export default {
    modules: defaultModules(),
    categories: defaultCategories(),
    subcategories: defaultSubcategories(),
    form: defaultForm(),
    formBuilders: defaultFormBuilders(),
    filterForms: defaultFilterForms(),
    categoriesForModule: defaultCategoriesForModule(),
    formByCategory: defaultFormByCategory(),
    submissionsEpps: defaultSubmissionsEpps(),
};
